export default __webpack_public_path__ + "static/media/s3_male.3c37d1b9.wav";